import { Action } from '@ngrx/store';
import { UsuarioEscenario } from 'src/app/models/SicarMap/Escenario/UsuarioEscenario.model';


export enum ShareSceneTypes {
  SCENE_SHARE = '[SCENE] Share ',
  SCENE_SHARE_SUCCESS = '[SCENE] ShareSuccess',
  SCENE_SHARE_FAILURE = '[SCENE] ShareFailure',
  SCENE_SHARE_RESET = '[SCENE] ShareReset ',
}

export class SceneShareReset implements Action {
  readonly type = ShareSceneTypes.SCENE_SHARE_RESET;
  constructor() {}
}
export class SceneShare implements Action {
  readonly type = ShareSceneTypes.SCENE_SHARE;
  constructor(public usuariosS: UsuarioEscenario[]) {}
}

export class SceneShareSuccess implements Action {
  readonly type = ShareSceneTypes.SCENE_SHARE_SUCCESS;
  constructor(public result: UsuarioEscenario[]) {}
}

export class SceneShareFailure implements Action {
  readonly type = ShareSceneTypes.SCENE_SHARE_FAILURE;
  constructor(public payload: any) {}
}


export type SceneShareAcciones =
  | SceneShare
  | SceneShareSuccess
  | SceneShareFailure
  | SceneShareReset;